import script from "./AdminPedidosSeguimiento.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminPedidosSeguimiento.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__